import { useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { useQuery, QueryClient, QueryClientProvider } from '@tanstack/react-query';
import '../css/App.css';
import '../css/button.css';
import { useDocumentTitle } from '../ts/useDocumentTitle';

type PartyUser = { id: number; name: string; points: number };
type Party = { id: number; users: PartyUser[], started: boolean };

async function fetchParty(partyId: number): Promise<Party> {
  const response = await fetch(`http://localhost:5001/api/parties/${partyId}`);
  if (!response.ok) {
    const text = await response.text();
    throw new Error(text || response.statusText);
  }
  return response.json();
}
async function getQuest() {  
  const response = await fetch(`http://localhost:5001/api/quests/random`);
  if (!response.ok) {
    const text = await response.text();
    throw new Error(text || response.statusText);
  } 
  return response.json();
}

// async function addPoints(partyId: number, userId: number, points: number) {
//   const response = await fetch(`http://localhost:5001/api/users/addpoints/${partyId}/${userId}/${points}`, {
//     method: 'POST',
//   });
// }
type PartyState = {
  partyId?: number;
  playerName?: string;
  started?: boolean;
};

type Quest = {
  name: string;
  points: number;
  description: string;
};

function GameComponent() {
  useDocumentTitle('Game');
  const { gameId, playerId } = useParams();
  const party = useLocation();
  const partyState = (party.state as PartyState) ?? {};
  const partyId = partyState.partyId ?? Number(gameId);
  const displayCode = (gameId ?? '').toString().padStart(6, '0');
  const {
    data: questData,
    refetch: refetchQuest,
    isFetching: isQuestFetching,
    isError: isQuestError,
    error: questError,
  } = useQuery<Quest, Error>({
    queryKey: ['quest'],
    queryFn: () => getQuest(),
    staleTime: 0,
    refetchOnWindowFocus: false,
  });
  const {
    data: partyData,
  } = useQuery<Party, Error>({
    queryKey: ['party', partyId],
    queryFn: () => fetchParty(partyId as number),
    enabled: typeof partyId === 'number',
    retry: 0,
  });

  const players = partyData?.users ?? [];
  console.log(questData);
  function getPlayerName() {
    const playerIdNum = Number(playerId);
    for (let i = 0; i < players.length; i++) {
      if (players[i].id === playerIdNum) {
        return players[i].name;
      }
    }
    return playerIdNum || null;
  }
  function getPlayerScore() {
    const playerIdNum = Number(playerId);
    for (let i = 0; i < players.length; i++) {
      if (players[i].id === playerIdNum) {
        return players[i].points;
      } 
    }
    return 0;
  }
  
  const playerLabel = getPlayerName() ?? 'Player';

  return (
    <div className="App">
      <header className="App-header">
        <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', maxWidth: '960px', padding: '0 24px' }}>
          <span style={{ color: '#ffffff', fontWeight: 600 }}>{playerLabel}</span>
          <span style={{ color: '#05d9e8', letterSpacing: '1px', fontWeight: 700 }}>{displayCode}</span>
        </div>
      </header>
      <main className="App-body">
        <div className="content-card">
          <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', justifyContent: 'center', width: '100%' }}>
            <span className="code-pill-first">1st</span>
            <span className="code-pill">Score: {getPlayerScore()} pts</span>
   
          </div>

          {isQuestError && <p style={{ color: '#ff6b6b' }}>Failed to load challenge: {questError?.message}</p>}

          {questData && (
            <div className='list-panel'>
              <h3 style={{ margin: 0, color: '#05d9e8' }}>Current Challenge</h3>
              <p style={{ margin: '6px 0', color: '#ffffff' }}>{questData.description}</p>
              <p className='player-points'>Reward: {questData.points} pts</p>

              <div className="button-row" style={{ marginTop: 8 }}>
                <button className='Base-button-ready' disabled={isQuestFetching} onClick={() => { refetchQuest(); }}>
                  {isQuestFetching ? 'Loading…' : 'Done'}
                </button>
                <button className='Base-button-not-ready' disabled={isQuestFetching} onClick={() => refetchQuest()}>
                  {isQuestFetching ? 'Loading…' : 'Skip'}
                </button>
              </div>
            </div>
          )}
        </div>
      </main>
      <footer className="App-footer"></footer>
    </div>
  );
}

export default function Game() {
  const [queryClient] = useState(() => new QueryClient());
  return (
    <QueryClientProvider client={queryClient}>
      <GameComponent />
    </QueryClientProvider>
  );
}
